import Tag, { ITag, ITagApiModel } from '@models/Tag.model';
import { api } from '@services';

interface IUpdateTag {
  id: string;
  name?: string;
  tagCategoryId: string;
  description?: string;
}

const updateTag = async ({ id, ...data }: IUpdateTag): Promise<ITag> => {
  const { data: tag } = await api.patch<ITagApiModel>(`/tags/${id}`, data);

  return Tag.fromApiModel(tag);
};

export { updateTag };
